import React from "react";

// This file was manually converted from the SVG because in this project we can't
// define additional webpack loaders (without ejecting the CRA). I tried to use
// inline loader syntax (require('!!react!svg-react!svgo!...')) but that didn't
// work.

export default props => (
  <svg
    {...props}
    width="500px"
    height="256px"
    viewBox="0 0 500 256"
    preserveAspectRatio="xMidYMin meet"
    version="1.1"
    xmlns="http://www.w3.org/2000/svg"
  >
    <title>bg_animated_catalog</title>
    <g
      id="--assets"
      stroke="none"
      strokeWidth="1"
      fill="none"
      fillRule="evenodd"
    >
      <g id="bg_animated_catalog" strokeWidth="2" stroke="#003B5C">
        <g id="wireframe" transform="translate(13.000000, 0.000000)">
          <g id="aside">
            <path d="M100,0 L100,500" id="window" />
            <g
              id="logo"
              transform="translate(29.000000, 17.000000)"
              strokeLinecap="round"
              strokeLinejoin="round"
            >
              <polyline id="Line" points="0 7 15 23 31 7" />
              <polyline id="Line" points="7 2 15 23 24 2" />
              <path d="M15,23 L15,0" id="Line" />
            </g>
            <path d="M88,51 L0,51 L88,51 Z" id="Path" />
            <path d="M88,64 L0,64 L88,64 Z" id="Path" />
            <path d="M88,77 L0,77 L88,77 Z" id="Path" />
            <path d="M88,86 L21,86 L88,86 Z" id="Path" />
            <path d="M88,95 L21,95 L88,95 Z" id="Path" />
            <path d="M87,104 L20,104 L87,104 Z" id="Path" />
            <path d="M88,121 L0,121 L88,121 Z" id="Path" />
            <path d="M88,134 L0,134 L88,134 Z" id="Path" />
            <path d="M88,147 L0,147 L88,147 Z" id="Path" />
          </g>
          <g id="main" transform="translate(124.000000, 24.000000)">
            <polygon id="Rectangle" points="1 0 316 0 316 20 1 20" />
            <g id="colors" transform="translate(0.000000, 36.000000)">
              <g id="swatch">
                <rect id="box" x="1" y="0" width="48" height="48" />
                <path d="M50,60 L0,60 L50,60 Z" id="Path" />
              </g>
              <g id="swatch" transform="translate(67.000000, 0.000000)">
                <rect id="box" x="1" y="0" width="48" height="48" />
                <path d="M50,60 L0,60 L50,60 Z" id="Path" />
              </g>
              <g id="swatch" transform="translate(133.000000, 0.000000)">
                <rect id="box" x="1" y="0" width="48" height="48" />
                <path d="M50,60 L0,60 L50,60 Z" id="Path" />
              </g>
              <g id="swatch" transform="translate(266.000000, 0.000000)">
                <rect id="box" x="1" y="0" width="48" height="48" />
                <path d="M50,60 L0,60 L50,60 Z" id="Path" />
              </g>
              <g id="swatch" transform="translate(200.000000, 0.000000)">
                <rect id="box" x="1" y="0" width="48" height="48" />
                <path d="M50,60 L0,60 L50,60 Z" id="Path" />
              </g>
            </g>
            <g id="text" transform="translate(200.000000, 115.500000)">
              <path d="M116,0.5 L0,0.5 L116,0.5 Z" id="Path" />
              <path d="M116,34.5 L0,34.5 L116,34.5 Z" id="Path" />
              <path d="M116,17.5 L0,17.5 L116,17.5 Z" id="Path" />
              <path d="M116,50.5 L0,50.5 L116,50.5 Z" id="Path" />
              <path d="M116,67.5 L0,67.5 L116,67.5 Z" id="Path" />
              <path d="M90,84.5 L0,84.5 L90,84.5 Z" id="Path" />
            </g>
            <g id="image" transform="translate(1.000000, 113.000000)">
              <rect id="Rectangle" x="0" y="0" width="181" height="95" />
              <polyline
                id="Fill-993"
                strokeLinecap="square"
                points="181 94 127.256923 52 100.524615 76 60.4261538 46 0 94"
              />
              <circle id="Path" cx="153" cy="28" r="12" />
            </g>
          </g>
        </g>
      </g>
    </g>
  </svg>
);



// WEBPACK FOOTER //
// ./src/assets/images/background/bg_wireframe_catalog-static.svg.js